<template>
    <div class="px-container mt-6 relative" id="products-series">
        <div class="loading" v-show="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div
            class="border border-xp-line-grey lg:rounded-md divide-y divide-xp-line-grey"
        >
            <a
                v-for="product in products"
                :href="product.link"
                class="flex flex-col lg:flex-row justify-between items-center gap-5 pl-2 pr-10 py-6"
                v-bind:key="product.id"
            >
                <div
                    class="flex flex-col lg:flex-row items-center justify-center gap-5 lg:w-1/4 overflow-hidden"
                >
                    <img
                        :src="product.image"
                        alt=""
                        class="w-[120px] h-[120px] object-contain object-center"
                    />
                    <div class="text-center lg:text-left">
                        <h3
                            class="text-2xl font-black tracking-1 uppercase"
                        >
                            {{ product.name }}
                        </h3>
                        <p class="text-black tracking-1 text-2xl">
                            {{ product.range }}
                        </p>
                    </div>
                </div>
                <div
                    class="search-results--item-description lg:w-1/2 font-normal prose prose-ul:xl:columns-2 prose-li:pr-5 prose-ul:pl-5 prose-li:list-none prose-li:my-1 prose-li:before:content-['\25BA_\0020'] prose-li:before:text-[10px] prose-li:before:mr-2 prose-li:before:-ml-5 prose-li:before:align-text-bottom prose-li:before:text-xp-lilac"
                    v-html="product.description"
                ></div>
                <div>
                    <button
                        type="button"
                        id="reset_filters"
                        class="inline-flex items-center gap-3 rounded text-black uppercase font-bold border-2 border-xp-carbon py-1.5 px-3 hover:border-xp-electron-green hover:bg-xp-electron-green tracking-[2.51px] text-sm"
                    >
                        More info
                    </button>
                </div>
            </a>
        </div>
        <pagination
            v-if="products.length"
            :page-count="pagination.page_count"
            :cur-page="pagination.cur_page"
            @change-page="setCurrentPage"
            class="pt-12 pb-12 lg:pt-24"
        />
    </div>
</template>

<script>
import FilterableList from "../../../../mixins/products/FilterableList";

export default {
    name: "ProductSeriesList",
    mixins: [FilterableList],
};
</script>
